import { Flex, Popover } from 'antd';
import IWarning from 'Assets/icons/warning-info.svg';

import styles from './styles.less';

import { ErrorType, ResponseErrorType } from '@/types/api';
import { getErrorMessage } from '@/utils/common';

interface Props {
  groupMessage?: string;
  error: ResponseErrorType;
}

const getValidationErrorMessage = (errors?: ErrorType[]) => {
  try {
    if (errors) {
      return errors.flatMap(i => <div key={i.field}>{`${i.field}: ${i.message}`}</div>);
    }
    return '';
  } catch (e) {
    console.error(e);
    return '';
  }
};

function ErrorMessageServer({ error, groupMessage }: Props) {
  const message = groupMessage || getErrorMessage(error);
  return (
    <Flex className="text-error" title={message}>
      {message}

      <Popover
        content={getValidationErrorMessage(error?.data?.devErr)}
        placement="top"
        trigger="hover">
        <img className={styles.errorIcon} src={IWarning} alt="error" />
      </Popover>
      {/* )} */}
    </Flex>
  );
}

export default ErrorMessageServer;
